import PropTypes from "prop-types";

// material-ui
import { Divider, List, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { TIENDA_HANDY } from "config";

// project imports
import NavCollapse from "../NavCollapse";
import NavItem from "../NavItem";

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();

  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case "collapse":
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case "item":
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        sx={{ py: TIENDA_HANDY ? 0 : null }}
        subheader={
          item.title && (
            <Typography
              variant="caption"
              sx={{
                ...theme.typography.menuCaption,
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                color: theme.palette.text.secondary,
                px: 2,
                py: 1,
                mb: 1,
              }}
              display="block"
              gutterBottom>
              {item.title}
              {item.caption && (
                <Typography
                  variant="caption"
                  sx={{
                    ...theme.typography.subMenuCaption,
                    opacity: 0.7,
                    fontWeight: 400,
                    textTransform: "none",
                    letterSpacing: "normal",
                  }}
                  display="block"
                  gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }>
        {items}
      </List>

      {/* group divider */}
      {TIENDA_HANDY && (
        <Divider
          sx={{
            borderWidth: 1,
            mx: 2,
            borderColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
            my: 1,
          }}
        />
      )}
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
};

export default NavGroup;
